import { render } from "./BankRecTable.vue?vue&type=template&id=2b31e1c0"
import script from "./BankRecTable.vue?vue&type=script&lang=js"
export * from "./BankRecTable.vue?vue&type=script&lang=js"

import "./BankRecTable.vue?vue&type=style&index=0&id=2b31e1c0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__